




export default {
  name: 'EyeOffIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
